import './navigation';
import './header';
import './ajax-add-to-cart';
import './smooth';
